(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('auri-gallery-arrows')) {
    customElements.define('auri-gallery-arrows', class extends HTMLElement {
      connectedCallback() {
        this.gallery = this.closest('media-gallery');
        this.previous = this.querySelector('[data-direction="previous"]');
        this.next = this.querySelector('[data-direction="next"]');
        if (!this.gallery || !this.previous || !this.next) return;
        this.onClick = (event) => {
          const control = event.target.closest('[data-direction]');
          if (!control || control.disabled) return;
          const thumbnails = this.getThumbnails();
          const current = thumbnails.findIndex((button) => button.getAttribute('aria-current') === 'true');
          const index = Math.max(0, current) + (control.dataset.direction === 'next' ? 1 : -1);
          if (thumbnails[index]) thumbnails[index].click();
        };
        this.addEventListener('click', this.onClick);
        this.observer = new MutationObserver(() => this.updateControls());
        this.observer.observe(this.gallery, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-current', 'class'] });
        this.onResize = () => this.updateControls();
        window.addEventListener('resize', this.onResize);
        this.updateControls();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.removeEventListener('click', this.onClick);
        window.removeEventListener('resize', this.onResize);
      }
      getThumbnails() {
        return Array.from(this.gallery.querySelectorAll('[id^="GalleryThumbnails"] [data-target]'))
          .filter((item) => item.offsetWidth > 0 && getComputedStyle(item).display !== 'none')
          .map((item) => item.querySelector('button'))
          .filter(Boolean);
      }
      updateControls() {
        const thumbnails = this.getThumbnails();
        const current = Math.max(0, thumbnails.findIndex((button) => button.getAttribute('aria-current') === 'true'));
        this.toggleAttribute('data-ready', thumbnails.length > 1);
        this.previous.disabled = current === 0;
        this.next.disabled = current >= thumbnails.length - 1;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
